module.exports = __webpack_public_path__ + "fonts/Inter.var.4b97690.woff2";